import React, { useState } from 'react';
import BaseLayout from '../../components/BaseLayout.js';
import Card from '../../components/Card.js';
import Title from '../../components/Title.js';
import LongInput from '../../components/LongInput.js';
import ShortButton from '../../components/ShortButton.js';
import LoadingDots from '../../components/LoadingDots.js';
import { resendVerification } from '../../api/axios.js';

const Verify = () => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const validateEmail = (email) => {
    if (!email) {
      return 'Email is required';
    }
    
    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }
    
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({});
    setStatusMessage('');

    const emailError = validateEmail(email);
    if (emailError) {
      setErrors({email: emailError});
      return;
    }

    setIsLoading(true);

    try {
      await resendVerification(email);
      setStatusMessage("If that email exists, you will receive a verification email shortly.");
    } catch (error) {
      setErrors({miscError: error.response?.data?.message || "There was an error sending the verification email. Please try again later."});
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          .form-container {
            margin: 0 auto;
            padding: 0 24%;
            display: flex;
            flex-direction: column;
            padding-top: 6%;
          }

          .form-fields {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 24px;
            width: 100%;
            padding-top:10%;
          }

          .input-gap {
            margin-bottom: 16px;
          }

          .button-gap {
            margin-bottom: 12px;
          }

          .remember-password {
            width: 90%;
            text-align: right;
          }

          .remember-password-button {
            color: #E1E1E6;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            background: none;
            border: none;
            cursor: pointer;
          }

          .remember-password-button:hover {
            color: #9797FA;
          }

          .status-message {
            width: 100%;
            color: #E1E1E6;
            text-align: center;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 300;
            line-height: 140%;
            margin-top: 16px;
          }

          .error-message {
            color: #ff4d4f;
            margin: 8px 0;
            text-align: center;
            width: 100%;
          }
        `}
      </style>

      <BaseLayout>
        <div className="form-container">
          <Card>
            <Title text="Verify Account" />
            <form onSubmit={handleSubmit} className="form-fields">
              <LongInput 
                text="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                error={errors.email}
              />

              <div className="remember-password button-gap">
                <button className="remember-password-button" type="button" onClick={() => window.history.back()}>
                  Go back to Login?
                </button>
              </div>

              <ShortButton 
                text={isLoading ? <LoadingDots/> : "Confirm"} 
                type="submit"
                disabled={isLoading} />

              {statusMessage && (
                <div className="status-message">
                  {statusMessage}
                </div>
              )}
              {errors.miscError && <div className="error-message">{errors.miscError}</div>}
            </form>
          </Card>
        </div>
      </BaseLayout>
    </>
  );
};

export default Verify;